// src/components/scheduling/TestDatePicker.jsx
// Temporary test component for the DatePicker
import React, { useState } from 'react';
import DatePicker from './DatePicker';

const TestDatePicker = () => {
  const [selectedDates, setSelectedDates] = useState([]);
  const [timeSlot, setTimeSlot] = useState({ start: '10:00', duration: 60 });
  const [conflictDates] = useState(['2025-01-15', '2025-01-22']); // Mock conflicts

  const handleDatesChange = (newDates) => {
    console.log('Dates changed:', newDates);
    setSelectedDates(newDates);
  };

  const handleTimeSlotChange = (newTimeSlot) => {
    console.log('Time slot changed:', newTimeSlot);
    setTimeSlot(newTimeSlot);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-6">
          DatePicker Component Test
        </h1>
        
        <DatePicker
          selectedDates={selectedDates}
          onDatesChange={handleDatesChange}
          timeSlot={timeSlot}
          onTimeSlotChange={handleTimeSlotChange}
          conflictDates={conflictDates}
        />

        {/* Debug Output */}
        <div className="mt-8 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3">Debug Output</h2>
          <div className="space-y-2">
            <div>
              <strong className="text-gray-900 dark:text-gray-100">Selected Dates:</strong>
              <pre className="bg-gray-100 dark:bg-gray-700 p-2 rounded mt-1 text-sm overflow-auto text-gray-900 dark:text-gray-100">
                {JSON.stringify(selectedDates, null, 2)}
              </pre>
            </div>
            <div>
              <strong className="text-gray-900 dark:text-gray-100">Time Slot:</strong>
              <pre className="bg-gray-100 dark:bg-gray-700 p-2 rounded mt-1 text-sm text-gray-900 dark:text-gray-100">
                {JSON.stringify(timeSlot, null, 2)}
              </pre>
            </div>
            <div>
              <strong className="text-gray-900 dark:text-gray-100">Conflict Dates:</strong>
              <pre className="bg-gray-100 dark:bg-gray-700 p-2 rounded mt-1 text-sm text-gray-900 dark:text-gray-100">
                {JSON.stringify(conflictDates, null, 2)}
              </pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestDatePicker;